import { Paths } from "Paths";
import { sortAlphabetically } from "Util/sortAlphabetically";
import { AppBar, IconButton, List, ListItem, ListSubheader, Paper, Toolbar, Typography } from "@material-ui/core";
import { ArrowBack, ChevronRight, ExpandMore } from "@material-ui/icons";
import { TreeItem, TreeView } from "@material-ui/lab";
import React from "react";
import { Link } from "react-router-dom";
import { priceFields, priceFieldZones } from './priceFields';
import { zones } from './zones';

//function createNode(priceField: string, zone: string, parentZones: string[]){
//    const zones = [...parentZones, zone]
//    const zonesId = zones.join('-')
//    if(!zone || zone in parentZones){
//        return <TreeItem nodeId={zonesId+priceField} label={priceField} />
//    }
//    return <TreeItem nodeId={zonesId}>{createNode()}</TreeItem>
//}

const priceFieldKeys = Object.keys(priceFields)
const unusedZones = zones.filter(z => !priceFieldKeys.includes(z))

function createSingleLayerTree() {
    return Object.keys(priceFields).sort(sortAlphabetically).map((zone) => {
        const zonePriceFields = priceFields[zone]
        return (
            <TreeItem nodeId={zone} label={/*`${(zonePriceFields?.length || 0) < 10 ? '0' : ''}${zonePriceFields?.length || 0}__` + */zone} key={zone}>
                {zonePriceFields?.sort(sortAlphabetically).map(priceField => (
                    <TreeItem nodeId={zone + priceField} label={priceField} key={zone + priceField}>
                        {priceFieldZones[priceField]?.length > 1 ? priceFieldZones[priceField]?.sort(sortAlphabetically).map(subZone => (
                            <TreeItem nodeId={zone + priceField + subZone} label={subZone} key={zone + priceField + subZone} />
                        )) : null}
                    </TreeItem>

                ))}
            </TreeItem>
        )
    })
}

const tree = createSingleLayerTree()

export function CategoryExplorer() {
    return (
        <>
            <AppBar>
                <Toolbar>
                    <IconButton color="inherit" component={Link} to={Paths.DASHBOARD}>
                        <ArrowBack />
                    </IconButton>
                    <Typography>Kategoriutforsker</Typography>
                </Toolbar>
            </AppBar>
            <Toolbar />
            <List>
                <ListItem>
                    <Paper style={{ padding: '20px' }} elevation={4}>
                        <Typography variant="body2">
                            Denne siden blir brukt til å visualisere alle soner og prisfelt som er i aktiv bruk.<br />
                            Feltene er hentet fra alle organisasjoner i det eksisterende systemet (uten priser selvfølgelig)<br />
                            Formålet med denne skjermen er å hjelpe utviklingen av appen (blir ikke værende i produksjon)

                        </Typography>
                    </Paper>
                </ListItem>
                <ListSubheader>Ubrukte soner</ListSubheader>
                <ListItem>
                    <TreeView defaultCollapseIcon={<ExpandMore />} defaultExpandIcon={<ChevronRight />}>
                        {unusedZones.map(zone => (
                            <TreeItem nodeId={zone} label={zone} key={zone} />
                        ))}
                    </TreeView>
                </ListItem>
                <ListSubheader>{'Sone -> Prisfelter for sone -> Prisfeltets soner'}</ListSubheader>
                <ListItem>
                    <TreeView defaultCollapseIcon={<ExpandMore />} defaultExpandIcon={<ChevronRight />}>
                        {
                            tree
                        }
                    </TreeView>
                </ListItem>
            </List>
        </>
    )
}
